module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "baltimore_banner.b8304e15.png";